import React from 'react';
import {
  FixedWidth,
  DataValueColorNavy,
} from '../../../../../../CommonComponents/commonStyles';
import { ContributionsHead } from './styles';
import {
  Types,
  ContentMessage,
} from '../../../../../../CommonComponents/ContentMessages';
import Preloader from '../../../../../../CommonComponents/Preloader/Preloader';
import PropTypes from 'prop-types';

export default function DashboardSummary(props) {
  const { accData } = props;
  return (
    <FixedWidth className='mb-50'>
      <ContributionsHead>
        {' '}
        <ContentMessage
          page='Contributions Overview'
          type={[Types.PAGE_TITLE_DESCRIPTION]}
          property='field_page_title'
          defaultMessage={<Preloader styling='btnLoader' />}
        ></ContentMessage>
      </ContributionsHead>
      <DataValueColorNavy isBreak className='mt-10 name-handle'>
        {accData.accountName} - {accData.accountId}
      </DataValueColorNavy>
    </FixedWidth>
  );
}

DashboardSummary.propTypes = {
  accData: PropTypes.shape({
    accountId: PropTypes.string,
    accountName: PropTypes.string,
    availableBalance:  PropTypes.number,
    beginBalance: PropTypes.number,
    contributionYTD: PropTypes.number,
    currentBalance: PropTypes.number,
    dateChanged: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    endBalance: PropTypes.number,
    grantsAndContribution: PropTypes.number,
    marketMovement: PropTypes.number,
    roleAccess: PropTypes.string,
    ytdPercentage: PropTypes.number,
    ytdPercentageIncrease: PropTypes.bool,
  }),
};
